import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService, SessionService, AppService } from '../../services';
import { User, Container } from '../../models';

@Component({
  selector: 'profile-icon',
  templateUrl: './profile-icon.component.html',
  styleUrls: ['./profile-icon.component.scss']
})
export class ProfileIconComponent implements OnInit {

  mfaIsEnabled: boolean;
  user: User;
  workingContainer: Container;

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _sessionService: SessionService,
    private _appService: AppService
  ) { }

  ngOnInit() {
    this.mfaIsEnabled = this._sessionService.getIs2faEnabled();
    this.user = this._sessionService.getUserDetails();
    this.workingContainer = this._sessionService.getWorkingContainer();
    this._appService.onContainerChanged.subscribe((container: Container) => {
      this.workingContainer = container;
    });
  }

  enableMfa(): void {
    this._router.navigate(['/setup-2fa']);
  }

  disableMfa(): void {
    this._authService.disable2fa();
  }

  logOut(): void {
    this._authService.logout();
  }

}
